import { useCallback, useRef, useState } from "react";
import Webcam from 'react-webcam'
import Placeholder from '../../../../images/player-placeholder.png'
import WebcamCapture from "./WebcamCapture";
import PhotoSelectionBtn, {PhotoSource} from './PhotoSelectionBtn';
import Button from "../../Button";
import T from "../../../i18n/Text";
import Avatars from "./Avatars";

enum Option{
    IMG = "img",
    CAMERA = "camera",
    AVATAR = "avatar",
    NULL = "null",
}

interface Props {
    photo: string | null;
    onPhotoSet: (imgSrc: string) => void;
    name: string;
}

const AddPhoto = ({photo, onPhotoSet, name}:Props) => {
    const [imgSrc, setImgSrc] = useState<string | null>(photo || null);

    const fileInput = useRef<HTMLInputElement>(null);

    const webcamRef = useRef<Webcam>(null);

    const [photoSource, setPhotoSource] = useState(Option.NULL);

    const onAvatarSet = (url: string) => {
        setImgSrc(url);
        setPhotoSource(Option.NULL)
    };

    const capture = useCallback(() => {
        if (webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc) {
                setImgSrc(imageSrc);
                setPhotoSource(Option.NULL)
            }
        }
    }, [webcamRef]);

    const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        if (e.target.files) {
            const fileUploaded = e.target.files[0];
            let reader = new FileReader();
            reader.onloadend = () => {
                if (typeof (reader.result) === "string") {
                    setImgSrc(reader.result);
                }
            };
            reader.readAsDataURL(fileUploaded);
        }
        setPhotoSource(Option.NULL)
    };

    const onHandleImg = () => {
        setPhotoSource(Option.IMG);
        if (fileInput.current) {
            fileInput.current.click();
        }
    };
    const onHandleCamera = () => {
        setPhotoSource(Option.CAMERA);
        setImgSrc(null);
    };
    const onHandleAvatar = () => {
        setPhotoSource(Option.AVATAR);
    };
    const onAddPlayer = () => {
        if (imgSrc) {
            onPhotoSet(imgSrc)
        }
    };

    const title = !imgSrc ? <T path='games.titles.addImg'/> : <><T path={`games.titles.player`} /> {name}</>;
    const imgUrl = !imgSrc ? Placeholder : imgSrc;
    const imgView = <div className="w-[220px] h-[220px] mt-[16px] mb-[15px] rounded-full overflow-hidden">
                            <img className="object-cover min-w-full min-h-full" src={imgUrl} alt="player" />
                    </div>;
    const avatarView = <Avatars onAvatarSet={onAvatarSet} />;
    const cameraView = <WebcamCapture webcamRef={webcamRef} />;
    const buttonTxt = photo ? <T path='games.buttons.updatePlayer' /> : <T path='games.buttons.addPlayer' />;
    const buttonAddPlayer = <Button disabled={!imgSrc} type="primary" onClick={onAddPlayer} name="add-player">
                                {buttonTxt}
                            </Button>;
    const buttonTakePhoto = <Button disabled={false} type="primary" onClick={capture} name="take-photo"><T path='games.buttons.takePhoto'/></Button>;

    return (
        <>
            <h3 className="text-[20px] font-medium leading-6 m-0">{title}</h3>
            {photoSource === Option.CAMERA ? cameraView : (photoSource === Option.AVATAR ? avatarView : imgView )}
            <ul className="flex justify-between mb-[19px]">
                <li className="flex flex-col items-center mr-[42px] ">
                    <PhotoSelectionBtn selected={photoSource === Option.IMG} onClick={onHandleImg} source={PhotoSource.IMG} />
                    <input type="file" accept=".jpg, .jpeg, .png" ref={fileInput} onChange={handleUpload} className="hidden"/>
                </li>
                <li className="flex flex-col items-center mr-[49px]">
                    <PhotoSelectionBtn selected={photoSource === Option.CAMERA} onClick={onHandleCamera} source={PhotoSource.CAMERA}/>
                </li>
                <li className="flex flex-col items-center">
                    <PhotoSelectionBtn selected={photoSource === Option.AVATAR} onClick={onHandleAvatar} source={PhotoSource.AVATAR}/>
                </li>
            </ul>
            {photoSource === Option.CAMERA ? buttonTakePhoto : buttonAddPlayer }
        </>
    )
};

export default AddPhoto;
